<ion-header>
    <ion-toolbar class="ion-no-padding">

        <ion-title slot="start">{{Title}}</ion-title>

        <ion-buttons slot="end" *ngIf="CanClose" class="ion-padding-end">
            <ion-button style="margin-right: 8px;" fill="clear" color="dark" shape="round" (click)="Close()">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">

    <custom-camera *ngIf="IsCompleted" [overlayQRCode]="OverlayQRCode" [enableUI]="EnableUI"
        (callback)="OnGetImage($event)" (loaded)="OnCameraLoaded($event)"></custom-camera>


</ion-content>